// extracted by mini-css-extract-plugin
module.exports = {"Reseters":"BasicButton_Reseters__nGfNv"};